
<div class="w-full px-6 py-8 space-y-10 bg-white">
  <form [formGroup]="userEForm">
    <div class="bg-white rounded-2xl shadow-lg p-6 space-y-6">
      <div class="flex items-center justify-between border-b pb-2">
        <div class="flex items-center gap-2">
          <div class="w-[4px] h-6 bg-primary"></div>
          <h2 class="text-xl font-semibold text-gray-800">
            {{ 'branch.title' | translate }}
          </h2>
        </div>

        <button
          mat-raised-button
          color="primary"
          [disabled]="!userEForm.valid"
          (click)="onSubmit()"
        >
          {{ 'button.submit' | translate }}
        </button>
      </div>

      <div formArrayName="additionalBranch">
        <div *ngFor="let branch of additionalBranch.controls; let i = index" [formGroupName]="i">
          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ 'label.name' | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="primary_contact_name" required />
                <mat-error *ngIf="branch.get('primary_contact_name')?.hasError('required')">
                  {{ 'error.name_required' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>{{ 'label.email' | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="primary_contact_email" required />
                <mat-error *ngIf="branch.get('primary_contact_email')?.hasError('required')">
                  {{ 'error.email_required' | translate }}
                </mat-error>
                <mat-error *ngIf="branch.get('primary_contact_email')?.hasError('email')">
                  {{ 'error.invalid_email' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>{{ 'label.mobile' | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="primary_contact_phone" required />
                <mat-error *ngIf="branch.get('primary_contact_phone')?.hasError('required')">
                  {{ 'error.mobile_required' | translate }}
                </mat-error>
                <mat-error *ngIf="branch.get('primary_contact_phone')?.hasError('pattern')">
                  {{ 'error.mobile_pattern' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ 'label.office_name' | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput placeholder="officename" formControlName="branch_name" />
                <mat-error *ngIf="branch.get('branch_name')?.hasError('required')">
                  {{ 'error.office_required' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
             <div class="half-width">
              <mat-label>{{ "DOMAIN" | translate }}</mat-label>

              <mat-form-field appearance="outline" class="full-width">
                <mat-select formControlName="domain" [multiple]="true" required>
                  <mat-option value="Commercial">Commercial</mat-option>
                  <mat-option value="Education">Education</mat-option>
                  <mat-option value="Electric">Electric</mat-option>
                  <mat-option value="Gas">Gas</mat-option>
                  <mat-option value="Residential">Residential</mat-option>
                  <mat-option value="Road">Road</mat-option>
                  <mat-option value="Telecom">Telecom</mat-option>
                  <mat-option value="Water">Water</mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('domain')?.hasError('required')">
                  {{ "DOMAIN_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

          
          </div>
        
          <div class="flex flex-row gap-4">
                <div class="half-width">
              <mat-label>{{ "REG_NO" | translate }}</mat-label>

              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="registration_number" />
                <mat-error
                  *ngIf="
                    branch.get('registration_number')?.hasError('required')
                  "
                >
                  {{ "CIN_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
           
            <div class="half-width">
              <mat-label>{{ "GST_NO" | translate }}</mat-label>

              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="gst_number" />
                <mat-error
                  *ngIf="branch.get('gst_number')?.hasError('required')"
                >
                  {{ "GST_REQUIRED" | translate }}
                </mat-error>
                <mat-error
                  *ngIf="branch.get('gst_number')?.hasError('pattern')"
                >
                  {{ "GST_PATTERN_INVALID" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>{{ "PAN" | translate }}</mat-label>

              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="pan_number" />
                <mat-error
                  *ngIf="branch.get('pan_number')?.hasError('required')"
                >
                  {{ "PAN_REQUIRED" | translate }}
                </mat-error>
                <mat-error
                  *ngIf="branch.get('pan_number')?.hasError('pattern')"
                >
                  {{ "PAN_PATTERN_INVALID" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label> {{ "line1" | translate }}</mat-label>

              <mat-form-field appearance="outline">
                <input matInput formControlName="address_line_1" />
                <mat-error
                  *ngIf="branch.get('address_line_1')?.hasError('required')"
                >
                  {{ "employee.address" | translate }}
                  {{ "REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label> {{ "line2" | translate }}</mat-label>

              <mat-form-field appearance="outline">
                <input matInput formControlName="address_line_2" />
                <mat-error
                  *ngIf="branch.get('address_line_2')?.hasError('required')"
                >
                  {{ "employee.address" | translate }}
                  {{ "REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="flex flex-row gap-4">
              <div class="half-width">
              <mat-label>{{ 'label.country' | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <mat-select formControlName="country" (selectionChange)="onCountryBChange(i)" required>
                  <mat-option value="">{{ 'label.select_country' | translate }}</mat-option>
                  <mat-option value="India">{{ 'countryOption.india' | translate }}</mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('country')?.hasError('required')">
                  {{ 'error.country_required' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>{{ 'label.state' | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <mat-select formControlName="state" (selectionChange)="onStateBChange(i)" required>
                  <mat-option value="">{{ 'label.select_state' | translate }}</mat-option>
                  <mat-option *ngFor="let state of availableStates[i]" [value]="state">
                    {{ state }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('state')?.hasError('required')">
                  {{ 'error.state_required' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>{{ 'label.city' | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <mat-select formControlName="city" required>
                  <mat-option value="">{{ 'label.select_city' | translate }}</mat-option>
                  <mat-option *ngFor="let city of availableCities[i]" [value]="city">
                    {{ city }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('city')?.hasError('required')">
                  {{ 'error.city_required' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div >
              <button mat-stroked-button type="button" (click)="openPicker(i, branch)">
            {{ 'locateOnMap' | translate }}
          </button>
          </div>
        
          <div class="flex flex-row gap-4">
            
            <div class="half-width">
              <mat-label>{{ 'label.lat' | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput placeholder="lat" formControlName="lat" />
                <mat-error *ngIf="branch.get('lat')?.hasError('required')">
                  {{ 'error.lat_required' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            
            <div class="half-width">
              <mat-label>{{ 'label.long' | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput placeholder="long" formControlName="long" />
                <mat-error *ngIf="branch.get('long')?.hasError('required')">
                  {{ 'error.long_required' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>{{ 'label.pincode' | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput placeholder="pincode" formControlName="postal_code" />
                <mat-error *ngIf="branch.get('postal_code')?.hasError('required')">
                  {{ 'error.pincode_required' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

          </div>

          <div class="form-actions flex gap-4">
            <button
              *ngIf="additionalBranch.length > 1"
              mat-raised-button
              color="warn"
              type="button"
              (click)="removeBranch(i)"
              [disabled]="additionalBranch.length === 1"
            >
              {{ 'button.remove' | translate }}
            </button>
            <button mat-raised-button color="primary" type="button" (click)="addBranch()">
              {{ 'ADD_BRANCH' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

